"use strict";

PF.Field.FileOne = class FileOne extends PF.Field
	{
	static get options()
		{
		return {
			model: new PF.Model(),
			key: 'file',
			fileListConfig: {dom: {}, modelsConfig: {}},
			newItemData: {},
			errors: {}
		};
		}


	init()
		{
		this.fileListConfig.model = this.model;
		// if (this.fileListConfig.models === null)
		// 	{
		// 	this.fileListConfig.models = new PF.Models({parent: this.model});
		// 	this.model.setData(this.key, this.fileListConfig.models);
		// 	}
		this.fileListConfig.key = this.key;
		this.fileListConfig.dom.element = this.dom.element;

		this.fileList = new PF.FileOne(this.fileListConfig);
		// this.fileList.models.loadPart();
		}


	};
